export const bonuses = [
  {
    "name": "Badminton Warm-Ups and Finishers",
    "benefit": "Start and finish with purpose using 20 short activities that fit around your lessons.",
    "image": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/63a9e8d3-573d-425a-a98e-6a2fd549480b/23af58ab-5122-47fa-8d5d-aa1ba50a7731-mockup.webp?width=800&quality=85&resize=contain"
  },
  {
    "name": "Station Signs and Rotation Boards",
    "benefit": "Give every group a clear place, role and rotation with printable signs and boards.",
    "image": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/63a9e8d3-573d-425a-a98e-6a2fd549480b/944b4bee-0c43-405d-81ef-f57e4e889296-mockup.webp?width=800&quality=85&resize=contain"
  },
  {
    "name": "Student Progress Passports",
    "benefit": "Help learners record progress and choose their next practice target.",
    "image": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/63a9e8d3-573d-425a-a98e-6a2fd549480b/34794933-d615-4252-ba28-0e0ef74205d3-mockup.webp?width=800&quality=85&resize=contain"
  },
  {
    "name": "Low-Equipment Rescue Plans",
    "benefit": "Keep teaching with six contingency sessions for fewer rackets, missing nets or a change of space and time.",
    "image": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/63a9e8d3-573d-425a-a98e-6a2fd549480b/bfb476ae-4dd3-486a-8e4b-063bd956ba09-mockup.webp?width=800&quality=85&resize=contain"
  },
  {
    "name": "Substitute Teacher Quick-Start Kit",
    "benefit": "Hand over a clear plan with 40-minute and 30-minute lesson options, setup diagrams and teacher notes.",
    "image": "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/63a9e8d3-573d-425a-a98e-6a2fd549480b/27e6df9e-b6ec-4a60-9e91-b510915006ef-mockup.webp?width=800&quality=85&resize=contain"
  }
];
